import MainPresetsIcon from '@material-ui/icons/GroupWork';
import AdCategoriesIcon from '@material-ui/icons/Loyalty';
import BuilderIcon from '@material-ui/icons/Build';

export default [
  {
    "path": "/slicer",
    "label": "Ad Type Select",
    "icon": AdCategoriesIcon
  },
  {
    "path": "/preset",
    "label": "Ad Sets and Norms",
    "icon": MainPresetsIcon
  },

  {
    "path": "/builder",
    "label": "Builder",
    "icon": BuilderIcon
  }
]



// WEBPACK FOOTER //
// ./src/app/configuration/Max/config/sidebar.js